import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { UpdateCostCenterPriceModel } from 'src/app/models/others/update-cost-center-price.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UpdateCostCenterPriceService {

  constructor(private _httpClient: HttpClient) { }

  createAsync(updateCostCenterPriceModel: UpdateCostCenterPriceModel): Observable<UpdateCostCenterPriceModel> {
    return this._httpClient.post<UpdateCostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPrice.CreateAsync}`,
      updateCostCenterPriceModel);
  }

  deleteAsync(updateCostCenterPriceId: number): Observable<UpdateCostCenterPriceModel> {
    return this._httpClient.delete<UpdateCostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPrice.DeleteAsync}/${updateCostCenterPriceId}`);
  }

  getByIdAsync(updateCostCenterPriceId: number): Observable<UpdateCostCenterPriceModel> {
    return this._httpClient.get<UpdateCostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPrice.GetByIdAsync}/${updateCostCenterPriceId}`);
  }

  getUpdateCostCenterPriceByKeys(branchId: number, consecutive: number): Observable<UpdateCostCenterPriceModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<UpdateCostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPrice.GetUpdateCostCenterPriceByKeysAsync}`,
      { params: params }
    );
  }

  getFirstUpdateCostCenterPriceByKeys(branchId: number): Observable<UpdateCostCenterPriceModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<UpdateCostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPrice.GetFirstUpdateCostCenterPriceByKeysAsync}`,
      { params: params }
    );
  }

  getLastUpdateCostCenterPriceByKeys(branchId: number): Observable<UpdateCostCenterPriceModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<UpdateCostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPrice.GetLastUpdateCostCenterPriceByKeysAsync}`,
      { params: params }
    );
  }

  getNextUpdateCostCenterPriceByKeys(branchId: number, consecutive: number): Observable<UpdateCostCenterPriceModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<UpdateCostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPrice.GetNextUpdateCostCenterPriceByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusUpdateCostCenterPriceByKeys(branchId: number, consecutive: number): Observable<UpdateCostCenterPriceModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<UpdateCostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPrice.GetPreviusUpdateCostCenterPriceByKeysAsync}`,
      { params: params }
    );
  }

  processUpdateCostCenterPrice(updateCostCenterPriceId: number): Observable<UpdateCostCenterPriceModel> {
    const params = new HttpParams().set('updateCostCenterPriceId', updateCostCenterPriceId)
    return this._httpClient.post<UpdateCostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPrice.ProcessUpdateCostCenterPrice}`,
      null, { params: params }
    );
  }

  updateAsync(updateCostCenterPriceModel: UpdateCostCenterPriceModel): Observable<UpdateCostCenterPriceModel> {
    return this._httpClient.put<UpdateCostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPrice.UpdateAsync}`,
      updateCostCenterPriceModel);
  }
}
